// import React, { useEffect } from "react";
// import { Row, Col } from "react-bootstrap";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import "sweetalert2/src/sweetalert2.scss";
// import { BsCoin } from "react-icons/bs";
// import { ImTarget } from "react-icons/im";
// import { FaChartLine } from "react-icons/fa";
// import aboutHero from "../../assets/img/healthh.png";
// import inspiration from "../../assets/img/health2.jpg";
// import infrastructure from "../../assets/img/healthh.png";
// import incrediants from "../../assets/img/health1.jpg";
// import cultivation from "../../assets/img/health3.jpg";
// import AboutCard from "./AboutCard";

// export default function About() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const fullViewInspiration = () => {
//     Swal.fire({
//       title: "INSPIRATION",
//       text: "In 2020 while most of us had to face the pandemic, we were in need of natural healthy products for our kids to improve the immunity.But we had access to only few and others were not available. So we started to cultivate on our own to satisfy our own needs. We have studied and analysed the benefits of most precious nature’s resources and started to made it available in our daily busy life.We constantly strive to develop products that are natural, safe, gentle, effective and yet environment friendly. We continually seek new techniques and ingredients to ensure that we offer the best possible natural and cost effective products to our consumers.",
//     });
//   };

//   const fullViewInfrastructure = () => {
//     Swal.fire({
//       title: "INFRASTRUCTURE",
//       text: "Our farm is located about 120 kms from Chennai that expands the landscape of about 2.5 Acers own Land. (15 Acers Leased Out) Hence it makes us feasible to cultivate all our ingredients in our farm that is free from Pesticides",
//     });
//   };

//   const fullViewIngrediants = () => {
//     Swal.fire({
//       title: "INGREDIANTS AND FREE OF HARMFUL CHEMICALS",
//       text: "We follow the Janu's Food Productsquality Ingredients Standard in all our proprietary formulations. We work hard to ensure that every ingredient delivers lasting results naturally. We are against using ingredients that promise quick results but are harmful to the skin in the long run. Then Free from petrochemicals, parabens, Genetically modified ingredients and other synthetic ingredients.",
//     });
//   };

//   const fullViewCultivation = () => {
//     Swal.fire({
//       title: "CULTIVATION",
//       text: "We use the highest possible concentration of organic and wild crafted(harvested from their natural or “wild” habitat, for food or medicinal purposes) ingredients in every treatment, and use cold-pressed, certified organic plant oils as the base whereve possible.Plants in Janu's Food Products are grown in their ideal habitats, which allow them to thrive and their essences to reach peak potential.",
//     });
//   };

//   return (
//     <>
//       <section class="py-5" style={{ backgroundColor: "#e0e0e0" }}>
//         <div class="container">
//           <div class="row align-items-center py-5">
//             <div class="col-md-8 text-white">
//               <h1 className="text-success">About Us</h1>
//               <p className="text-dark">
//                 At Janus Food products, we believe that cooking is more than
//                 just preparing meals—it’s a connection to tradition, nature, and
//                 health. Our journey began with a simple idea: to bring back the
//                 lost art of cooking with handcrafted, organic, and traditional
//                 cookware that enhances flavors while preserving health. Our
//                 Roots Nestled in the heart of kumbakonam, our story is inspired
//                 by the wisdom of our ancestors, who used pure clay pots, cast
//                 iron skillets, and stoneware to prepare meals rich in nutrition.
//                 We saw how modern, synthetic cookware was replacing these
//                 time-tested materials, and we knew it was time to revive the
//                 tradition. What We Do We source and craft 100% natural,
//                 toxin-free cookware made from clay, iron, bronze, and soapstone.
//                 Every piece is carefully designed to retain nutrients, enhance
//                 taste, and promote healthy cooking. Our products are made using
//                 eco-friendly processes, supporting artisans who have kept this
//                 craftsmanship alive for generations.
//               </p>
//             </div>
//             <div class="col-md-4">
//               <img src={aboutHero} alt="About Hero" className="img-fluid" />
//             </div>
//           </div>
//         </div>
//       </section>
//       <section class="container py-3">
//         <div class="row text-center pt-5 pb-3">
//           <div class="col-lg-12 m-auto">
//             <h1 class="h1">Our Story</h1>
//             <p>
//               Pure & Authentic – No harmful chemicals or coatings. Just nature’s
//               best. Handcrafted by Artisans – Each piece carries a story of
//               skill and heritage. Eco-Friendly & Sustainable – Good for you,
//               good for the planet. Enhances Taste & Health – Retains nutrients
//               and natural flavors. At Janus Food Products, we are not just
//               selling cookware—we are reviving a healthier, tastier, and more
//               sustainable way of life. Join us in bringing tradition back to
//               your kitchen!
//             </p>
//           </div>
//         </div>
//       </section>
//       <section class="container py-1">
//         <Row>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={inspiration}
//               cardStyle="aboutCard"
//               title="Inspiration"
//               contents="In 2020 while most of us had to face the pandemic, we were in need of natural healthy products..."
//               readMore={() => fullViewInspiration()}
//             />
//           </Col>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={infrastructure}
//               cardStyle="aboutCard"
//               title="Infrastructure"
//               contents="Our farm is located about 120 kms from Chennai that expands the
//               landscape..."
//               readMore={() => fullViewInfrastructure()}
//             />
//           </Col>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={incrediants}
//               cardStyle="aboutCard"
//               title="Ingredients Standard"
//               contents="We follow the Janu's Food Products quality Ingredients Standard in all our
//               proprietary formulations..."
//               readMore={() => fullViewIngrediants()}
//             />
//           </Col>
//           <Col xs={12} sm={6} md={6} lg={6} xl={3}>
//             <AboutCard
//               image={cultivation}
//               cardStyle="aboutCard"
//               title="Cultivation"
//               contents="We use the highest possible concentration of organic and wild crafted.."
//               readMore={() => fullViewCultivation()}
//             />
//           </Col>
//         </Row>
//         <div class="row d-flex justify-content-center my-3">
//           <div class="col-md-4 col-lg-4">
//             <div class="px-5 services-icon-wap">
//               <div class="h1 aboutIcon text-center">
//                 <ImTarget />
//               </div>
//               <h2 class="h5 mt-4 text-center">Mission</h2>
//               <p
//                 style={{
//                   textAlign: "justify",
//                   fontSize: "15px",
//                   fontWeight: "400",
//                 }}
//               >
//                 Plants in Janu's Food Products are grown in their ideal
//                 habitats, which allow them to thrive and their essences to reach
//                 peak potential.
//               </p>
//             </div>
//           </div>

//           <div class="col-md-4 col-lg-4">
//             <div class="px-5 services-icon-wap">
//               <div class="h1 aboutIcon text-center">
//                 <FaChartLine />
//               </div>
//               <h2 class="h5 mt-4 text-center">Vision</h2>
//               <p
//                 style={{
//                   textAlign: "justify",
//                   fontSize: "15px",
//                   fontWeight: "400",
//                 }}
//               >
//                 Currently we have launched skin/hair care products and
//                 fertilizers. By 2023 we are planning to emerge into various
//                 products such as food products, vegetables, fruits, pulses, etc
//               </p>
//             </div>
//           </div>

//           <div class="col-md-4 col-lg-4">
//             <div class="px-5 services-icon-wap">
//               <div class="h1 aboutIcon text-center">
//                 <BsCoin />
//               </div>
//               <h2 class="h5 mt-4 text-center">Values</h2>
//               <p
//                 style={{
//                   textAlign: "justify",
//                   fontSize: "15px",
//                   fontWeight: "400",
//                 }}
//               >
//                 We Sell the Highest Quality Natural and Organic products We
//                 satisfy and delight our customers Right product at the right
//                 quantity with right quality at right time.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }
// import React, { useEffect } from "react";
// import { Row, Col } from "react-bootstrap";
// import { FaHome, FaLeaf, FaTruck, FaCheckCircle } from "react-icons/fa";
// import Aboutt from "../../assets/img/final.jpg";
// import "./About.css"; // <-- ADD THIS

// export default function About() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   return (
//     <>
//       {/* Hero Section */}
//       <section style={{ backgroundColor: "#fff" }}>
//         <div className="container-fluid py-4">
//           <Row>
//             <Col xs={12} className="text-center">
//               <h1 className="about-title">About Us</h1>

//               {/* Image */}
//               <img src={Aboutt} alt="About" className="about-img" />

//               {/* Text */}
//               <p className="about-text">
//                  Welcome to our Healthy Food Store — where every bite is a step
//                 towards a healthier tomorrow! "For a healthier tomorrow — choose
//                 healthy food today" is not just our motto, it’s our promise.
//                 Each product is lovingly prepared using 100% natural methods,
//                 free from artificial flavors, colors, or preservatives. We
//                 believe in uncompromising quality, sourcing only the finest
//                 ingredients directly from trusted local farms. Our collection
//                 includes aromatic traditional spice powders, tangy homemade
//                 pickles, wholesome health mixes, and fresh premium-grade nuts —
//                 all designed to bring both taste and nutrition to your kitchen.
//                 Taste our products just once, and you’ll understand why our
//                 customers keep coming back. We guarantee a flavor and quality
//                 you’ll truly remember!
//               </p>
//             </Col>
//           </Row>
//         </div>
//       </section>

//       {/* Features */}
//       <section style={{ backgroundColor: "#faf6ef" }}>
//         <div className="container-fluid py-5">
//           <Row className="text-center">
//             <Col xs={12} sm={6} md={3} className="mb-4">
//               <div className="feature-icon">
//                 <FaHome />
//               </div>
//               <h5 className="mt-3 icons">100% Homemade</h5>
//             </Col>

//             <Col xs={12} sm={6} md={3} className="mb-4">
//               <div className="feature-icon">
//                 <FaLeaf />
//               </div>
//               <h5 className="mt-3 icons">No Artificial Additives</h5>
//             </Col>

//             <Col xs={12} sm={6} md={3} className="mb-4">
//               <div className="feature-icon">
//                 <FaTruck />
//               </div>
//               <h5 className="mt-3 icons">Sourced from Local Farms</h5>
//             </Col>

//             <Col xs={12} sm={6} md={3} className="mb-4">
//               <div className="feature-icon">
//                 <FaCheckCircle />
//               </div>
//               <h5 className="mt-3 icons">Quality Tested</h5>
//             </Col>
//           </Row>
//         </div>
//       </section>
//     </>
//   );
// }

import { useEffect } from "react";
import Aboutt from "../../assets/img/final.jpg";
import create from "../../assets/founder.png";
import Janu from "../../assets/janus.png";
import Janu1 from "../../assets/janus1.png";
import Janu2 from "../../assets/janus2.png";
import Janu3 from "../../assets/janus3.png";
import "./About.css";

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 useEffect(() => {
   const track = document.querySelector(".marquee-track");
   let speed = 1;
   let pos = 0;

   function animate() {
     pos -= speed;
     track.style.transform = `translateX(${pos}px)`;

     const first = track.children[0];
     const cardWidth = first.offsetWidth; // IMPORTANT: no extra gap added

     if (Math.abs(pos) >= cardWidth) {
       track.appendChild(first);
       pos += cardWidth; // exact wrap – NO GAP EVER
     }

     requestAnimationFrame(animate);
   }

   animate();
 }, []);

  return (
    <div>
      <div className="hero-new">
        <img src={Aboutt} alt="About Banner" />
      </div>

      <section className="about-intro">
        <h2>About Us</h2>

        <p>
          Janus Food Products is a health-focused, family-driven food brand
          founded in 2024 by <strong>Mrs. Sasikala Venkateswaran.</strong> Built
          on trust, purity, and care, our mission is to bring clean, healthy,
          and home-style food products to every household.
        </p>

        <p>
          We believe that food made with love and honesty can truly transform
          lives — and that belief is at the heart of everything we do.
        </p>
      </section>

      <section className="founder-wrapper">
        <div className="founder-left">
          <h1>Meet Our Founder</h1>
          <h2>Mrs. Sasikala Venkateswaran</h2>

          <p>
            A dedicated mother and passionate home-food creator, Mrs. Sasikala’s
            journey toward healthier cooking for her daughter Janani and
            diabetic family members led to the birth of this brand.
          </p>

          <p>
            “Food should heal, nourish, and support every family — from kids to
            elders.”
          </p>
        </div>

        <div className="founder-right">
          <div className="green-circle">
            <img
              src={create}
              alt="Founder"
              height={"100%"}
              width={"100%"}
              className="founder-img"
            />
          </div>
        </div>
      </section>

      <section className="journey-section">
        <div className="journey-card green-card">
          <h3>How Our Journey Began</h3>
          <p>
            Our story began with a mother’s care and responsibility. Mrs.
            Sasikala started preparing healthy, homemade food products for her
            daughter and diabetic family members.
          </p>
        </div>

        <div className="journey-card yellow-card">
          <h3>Our Roots in Kumbakonam</h3>
          <p>
            Janus Food Products proudly began in Kumbakonam — a city known for
            purity, tradition, and culture.
          </p>
        </div>

        <div className="journey-card red-card">
          <h3>Future Expansion</h3>
          <p>
            With increasing customer trust, Janus Food Products is expanding
            across Tamil Nadu and soon across India.
          </p>
        </div>
      </section>

      <section className="marquee-slider">
        <div className="marquee-track">
          {[
            {
              title: "Our Mission",
              img: Janu,
              list: [
                "Chemical-free, preservative-free products",
                "100% hygiene maintained",
                "Suitable for children & elders",
                "Affordable & trustworthy",
              ],
            },
            {
              title: "What We Offer",
              img: Janu1,
              list: [
                "Pure spices",
                "Traditional masalas",
                "Healthy mixes",
                "Grocery essentials",
              ],
            },
            {
              title: "Quality You Can Trust",
              img: Janu2,
              list: [
                "Premium raw materials",
                "Hygienic preparation",
                "No harmful chemicals",
                "Freshness-sealed packaging",
              ],
            },
            {
              title: "Why Choose Us?",
              img: Janu3,
              list: [
                "Inspired by real family health results",
                "Safe for diabetic patients & kids",
                "Authentic homemade taste",
                "Created with love and care",
              ],
            },
          ].map((card, i) => (
            <div className="marquee-card" key={i}>
              <img src={card.img} alt="Marquee" className="marquee-img" />

              <h3>{card.title}</h3>

              <ul>
                {card.list.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="vision-section">
        <h4>Our Vision</h4>
        <p>
          To become a trusted household name across India by offering pure,
          traditional, and healthy food products for every family.
        </p>
      </section>

      <footer className="footer">
        <p>Janus Food Products — Kumbakonam, Tamil Nadu</p>
        <p>Email: janusfoodproducts009@gmail.com | Phone: 9363043009</p>
      </footer>
    </div>
  );
}
